import React, { useState, useMemo, useEffect } from 'react';
import componentFunctions from '../../../../services/tools/componentFunctions';
import * as complianceServices from '../../../../services/complianceServices';

import css from './Compliance.module.css';
import commonCSS from '../../_common/styles/Common.module.css'

import Comparer from './Comparer';
import { Link } from 'react-router-dom';

function Compliance() {
    // const data = [
    //     {
    //         reference: 'Article 1',
    //         para: '145.A.10',
    //         new: 'I am not Sasho',
    //         old: 'I am Sasho',
    //     },
    //     {
    //         reference: 'Article 2',
    //         para: '145.A.20',
    //         new: 'This is Sparta',
    //         old: '',
    //     },
    //     {
    //         reference: 'Article 2a',
    //         para: '145.A.1',
    //         new: '',
    //         old: 'This is bulshit',
    //     },
    // ];
    const [filter, setFilter] = useState('');
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const [data, setData] = useState([]);

    console.log(process.env.REACT_APP_API_BASE_URL);
    

    useEffect(() => {
        let page;
        complianceServices
            .getAll(page || 1)
            .then((result) => {
                setData((state) => result.data.sort((a, b) => b.ID - a.ID) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter);
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    const headers = Object.keys(data[0]);

    return (
        <>
            <h1>COMMISSION IMPLEMENTING REGULATION (EU) 2023/989</h1>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                    //box-shadow: 0 0 8px 0 #54b5f7;
                    // style={{color: isError ? "red" : "black"}}
                />
                <div className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}>
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
                <Link to={'/compliance/add'}>
                    <button className={commonCSS.button}>+</button>
                </Link>
            </div>

            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort('origin')} className={css.th} style={{ cursor: 'pointer' }}>
                            Origin
                            {sortConfig.key === 'origin' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort('reference')} className={css.th} style={{ cursor: 'pointer' }}>
                            Reference
                            {sortConfig.key === 'reference' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th className={css.th}>Detail</th>
                        <th className={css.th}>Comment</th>
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((item, index) => (
                            <tr key={item.ID} id={item.ID} className={css.row}>
                                <td className={css.td}>
                                    {item.origin.split('\n').map((x) => (
                                        <p>{x}</p>
                                    ))}
                                </td>
                                <td className={css.td}>
                                    {item.reference.split('\n').map((x) => (
                                        <p>{x}</p>
                                    ))}
                                </td>
                                <td className={css.td}>
                                    {Number(item.toCompare) === 1 ? (
                                        <Comparer oldString={item.old || ''} newString={item.new || ''} />
                                    ) : (
                                        <>
                                            <Comparer oldString={item.old || ''} newString={''} />
                                            <Comparer oldString={''} newString={item.new || ''} />
                                        </>
                                    )}
                                </td>
                                <td className={css.td}></td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default Compliance;

// <div>
//     <h1>COMMISSION IMPLEMENTING REGULATION (EU) 2023/989</h1>
//     <table>
//         <thead>
//             <tr>
//                 <th>Reference</th>
//                 <th>Paragraph</th>
//                 <th>Change</th>
//                 <th>Comment</th>
//             </tr>
//         </thead>
//         {data.map((x) => (
//             <tr>
//                 <td>{x.reference}</td>
//                 <td>{x.para}</td>
//                 <td>
//                     <Comparer oldString={x.old} newString={x.new} />
//                 </td>
//                 <td>-</td>
//             </tr>
//         ))}
//     </table>
// </div>
